// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2s0xR","title":"Header_title__21XN4","left":"Header_left__1zLOy","clinicName":"Header_clinicName__3RKFw"};